import React from 'react';
import { Info } from 'lucide-react';

const AnalysisNote = ({ 
  message = "Este análisis es una guía inicial basada en las imágenes proporcionadas. Para un diagnóstico completo, te recomendamos consultar con tu veterinario.",
  color = "blue" 
}) => {
  const colorClasses = {
    blue: {
      bg: "bg-blue-50",
      text: "text-blue-800",
      icon: "text-blue-600"
    },
    green: {
      bg: "bg-green-50",
      text: "text-green-800",
      icon: "text-green-600"
    },
    red: {
      bg: "bg-red-50",
      text: "text-red-800",
      icon: "text-red-600"
    }
  };

  const { bg, text, icon } = colorClasses[color] || colorClasses.blue;

  return (
    <div className={`${bg} p-3 sm:p-4 rounded-lg`}>
      <div className={`flex items-start gap-2 ${text}`}>
        <Info className={`h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0 mt-0.5 ${icon}`} />
        <p className="text-sm sm:text-sm leading-relaxed">
          {message}
        </p>
      </div>
    </div>
  );
};

export default AnalysisNote;